import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const DocumentText = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='DocumentText' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M6,16 L16,16 L6,16 L6,16 Z M6,12 L18,12 L6,12 L6,12 Z M6,8 L11,8 L6,8 L6,8 Z M14,1 L14,8 L21,8 M3,23 L3,1 L15,1 L21,7 L21,23 L3,23 Z' />
  </StyledIcon>
);
